"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Clock, Calendar } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OperatingHours() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: hoursRef,
    isVisible: hoursVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: eventsRef,
    isVisible: eventsVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="operatinghours" className="py-16 md:py-24 bg-background">
      <div className="container">
        <div ref={headerRef} className={`mb-12 transition-all duration-500 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-foreground mb-3">Работно време</h2>
          <p className="text-muted-foreground max-w-2xl">Нашето работно време за посещения на място и доставки, както и възможностите за организиране на събития в заведението.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          <Card ref={hoursRef} className={`transition-all duration-500 delay-100 ${hoursVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <CardHeader>
              <div className="flex items-center gap-3 mb-2">
                <div className="flex items-center justify-center size-12 rounded-lg bg-primary/10">
                  <Clock className="size-6 text-primary" />
                </div>
                <CardTitle>Работно време</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h4 className="font-semibold text-foreground mb-2">
                  Понеделник - Петък
                </h4>
                <p className="text-muted-foreground">8:00 - 16:00</p>
              </div>
              
            </CardContent>
          </Card>

          <Card ref={eventsRef} className={`transition-all duration-500 delay-200 ${eventsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <CardHeader>
              <div className="flex items-center gap-3 mb-2">
                <div className="flex items-center justify-center size-12 rounded-lg bg-secondary/10">
                  <SafeHydrate><Calendar className="size-6 text-foreground" /></SafeHydrate>
                </div>
                <CardTitle>Организиране на събития</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h4 className="font-semibold text-foreground mb-2">
                  Понеделник - Петък
                </h4>
                <p className="text-muted-foreground">След 18:00 часа</p>
              </div>
              <div className="![padding:10px_0px_7px_0px]">
                <h4 className="font-semibold text-foreground mb-2">
                  Събота и Неделя
                </h4>
                <p className="text-muted-foreground">По всяко време</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}